import Popover from "components/Popover";
import { PaperDetails } from "helpers/api";
import { formatNumberWithCommas } from "helpers/formatNumberWithCommas";
import useLabels from "hooks/useLabels";
import InfluentialCitationsTooltip from "./InfluentialCitationsTooltip";

interface CitationDetailsProps {
  paper: PaperDetails;
}

export const CitationDetails = ({ paper }: CitationDetailsProps) => {
  const [citationsLabel, influentialCitationsLabel] = useLabels(
    "screens.details.citations",
    "screens.details.influential-citations"
  );

  return (
    <div className="flex gap-4">
      <div>
        <p className="lg-md">
          {formatNumberWithCommas(paper.citation_count ?? 0)}
        </p>
        <p className="sm-normal text-fg-muted">{citationsLabel}</p>
      </div>
      <div>
        <p className="lg-md">
          {formatNumberWithCommas(paper.influential_citation_count ?? 0)}
        </p>
        <p className="sm-normal text-fg-muted">
          {influentialCitationsLabel}
          &nbsp;
          <Popover interactive tooltipContent={<InfluentialCitationsTooltip />}>
            <i
              className="icon-info"
              aria-label="Influential Citations Info"
              data-testid="influential-citations-tooltip"
            />
          </Popover>
        </p>
      </div>
    </div>
  );
};
